export { mapBaseService } from './Base'
export { mapDetailedService } from './Detailed'
